<template>
  <div class="alturaMin">
    <Loading />
  </div>
</template>
<script>
// @ is an alias to /src
import { Donuz } from "donuz-js/Donuz";
import Loading from "../../components/Loading";

export default {
  components: { Loading },
  data() {
    return {
      obj: {},
      client: false,
      configs: {},
      loading: true
    };
  },
  async created() {
    this.obj = await this.getAdmins();
    this.obj = this.obj.estabelecimentos[0];

    let hash = atob(this.$route.params.data).split("-");
    if (this.$route.params.opt != undefined && this.$route.params.opt != null) {
      let origin =
        this.$route.params.opt.indexOf("http") !== false
          ? this.$route.params.opt + "/"
          : "http://" + this.$route.params.opt;

      if (time() > hash[0] || hash[0] > time() + 6 * 60 * 60) {
        location.href = origin;
      }
    }

    let result = await Donuz.customer.getInfoCustomer("accessAdmin", hash[1]);

    if (result.status == 200) {
      let client = result.clientes[0];
      let saldo = await Donuz.balance.getCustomerBalance(client.token);
      client.saldo = parseFloat(saldo.saldo)
        .toFixed(2)
        .replace(".", ",");
      sessionStorage.setItem(btoa("cliente"), btoa(JSON.stringify(client)));
      sessionStorage.setItem(btoa("tokenCliente"), client.token);
    }

    location.href = this.baseUrl;
  }
};
</script>

